import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef, useState } from 'react';
import { CalculateMenuPosition } from '../../Editor/CanvasHelpers';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { overrideRotationControl, setVisibilityControlsForObject, } from '../../Editor/CanvasService';
import TextObjectMenu from './TextObjectMenu';
import { CANVAS_OBJECT_ADDED, CANVAS_OBJECT_REMOVED, OBJECT_CHANGED, UPLOADED_IMAGES, } from '../../Rutab/RutabConstants';
import PathMenuContent from './PathMenuContent';
import { saveCanvasState } from '../../Actions/Rutab/HistoryActions';
const SelectedObjectMenu = memo(({ canvas, appSelector }) => {
    var _a;
    const bbbox = useSelector((state) => state.decalEditor.activeObjectLocationChanged);
    useSelector((state) => state.decalEditor.canvasSize);
    const [dynamicMenuWidth, setDynamicMenuWidth] = useState(0);
    const menuRef = useRef(null);
    const dispatch = useDispatch();
    const store = useStore();
    useEffect(() => {
        if (menuRef.current) {
            const newWidth = menuRef.current.clientWidth;
            if (newWidth !== dynamicMenuWidth) {
                setDynamicMenuWidth(newWidth);
            }
        }
    }, [bbbox, appSelector, dynamicMenuWidth]);
    if (appSelector.length === 0)
        return null;
    const activeObject = appSelector[0];
    if (!activeObject)
        return null;
    function isFabricImage(object) {
        return 'systemId' in object; // Kontrollera en unik egenskap för FabricImage
    }
    const copySelectedObject = () => {
        if (!activeObject)
            return;
        activeObject.clone().then((clonedObject) => {
            clonedObject.set({
                left: clonedObject.left + 10,
                top: clonedObject.top + 10,
                objectCaching: false,
                noScaleCache: false,
                borderColor: 'none',
                cornerColor: '#466c44',
                cornerSize: 12,
                cornerStyle: 'circle',
                transparentCorners: false,
            });
            if (isFabricImage(activeObject)) {
                clonedObject.systemId = activeObject.systemId;
            }
            setVisibilityControlsForObject(clonedObject);
            overrideRotationControl(clonedObject);
            canvas.add(clonedObject);
            canvas.setActiveObject(clonedObject);
            canvas.renderAll();
            dispatch({
                type: CANVAS_OBJECT_ADDED,
            });
        });
    };
    const alignVerticalCenter = () => {
        if (!activeObject)
            return;
        const zoom = canvas.getZoom();
        activeObject.set({
            top: canvas.height / 2 / zoom - activeObject.getBoundingRect().height / 2,
        });
        activeObject;
        activeObject.setCoords();
        canvas.renderAll();
        dispatch({
            type: OBJECT_CHANGED,
            payload: {
                activeObjectLocationChanged: activeObject.getBoundingRect(),
            },
        });
        dispatch(saveCanvasState(canvas));
    };
    const alignHorizontalCenter = () => {
        if (!activeObject)
            return;
        const zoom = canvas.getZoom();
        activeObject.set({
            left: canvas.width / 2 / zoom - activeObject.getBoundingRect().width / 2,
        });
        activeObject.setCoords();
        canvas.renderAll();
        dispatch({
            type: OBJECT_CHANGED,
            payload: {
                activeObjectLocationChanged: activeObject.getBoundingRect(),
            },
        });
        dispatch(saveCanvasState(canvas));
    };
    const deleteObject = () => {
        if (!activeObject)
            return;
        if (activeObject.type === 'image') {
            const imageObject = activeObject;
            const duplicatesOfTheImageOnCanvas = canvas === null || canvas === void 0 ? void 0 : canvas.getObjects().filter((img) => img.systemId == imageObject.get('systemId'));
            if (duplicatesOfTheImageOnCanvas.length === 1) {
                const uploadedImages = store.getState().decalEditorAPI.uploadedImages;
                dispatch({
                    type: UPLOADED_IMAGES,
                    payload: {
                        uploadedImages: uploadedImages.filter((img) => img.systemId !== imageObject.get('systemId')),
                    },
                });
            }
        }
        canvas.remove(activeObject);
        canvas.renderAll();
        dispatch({
            type: CANVAS_OBJECT_REMOVED,
        });
        dispatch(saveCanvasState(canvas));
    };
    activeObject.setCoords();
    const { top, left } = CalculateMenuPosition(dynamicMenuWidth || ((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 300, activeObject, canvas.upperCanvasEl, canvas.getZoom());
    return (_jsx(_Fragment, { children: _jsx("div", { ref: menuRef, className: "selected-object-menu ", style: {
                top: `${top}px`,
                left: `${left}px`,
            }, id: "selected-object-menu", children: _jsxs("div", { className: "object-menu-action selected-object-menu-guide", children: [activeObject.type === 'textbox' && (_jsxs(_Fragment, { children: [_jsx(TextObjectMenu, { canvas: canvas, activeObject: activeObject }), _jsx("div", { className: "vertical-line" })] })), activeObject.type === 'path' && (_jsxs(_Fragment, { children: [_jsx(PathMenuContent, { canvas: canvas, activeObject: activeObject }), _jsx("div", { className: "vertical-line" })] })), _jsx("img", { className: "cursor-pointer", src: "/images/align_vertical_center.svg", onClick: () => alignVerticalCenter() }), _jsx("img", { className: "cursor-pointer", src: "/images/align_horizontal_center.svg", onClick: () => alignHorizontalCenter() }), _jsx("div", { className: "vertical-line" }), _jsx("img", { className: "cursor-pointer", src: "/images/content_copy.svg", onClick: () => copySelectedObject() }), _jsx("div", { className: "vertical-line" }), _jsx("img", { src: "/images/delete.svg", className: "cursor-pointer", onClick: () => deleteObject() })] }) }) }));
});
export default SelectedObjectMenu;
